import React, { useState } from 'react';
import { IUploadedAsset } from '../../interfaces/assets.interface';
import ShowSelectedImage from './ShowSelectedImage';
import ImagesForm from './ImagesForm';
import { fetchMoreAssets } from '../../utils/assets.utils';
import { getActiveBrand } from '../../store/selector/brand.selector';
import { useAppDispatch, useAppSelector } from '../../store/store';
import { getAssetsPage, getAssetshasNext } from '../../store/selector/assets.selector';
import { useLazyGetUploadedAssetsQuery } from '../../store/api/editor.api';

interface IProps {
    show: boolean;
    onHide: () => void;
    onUpload: (imageUrl: string) => void;
}

const AssetsImages = ({ show, onHide, onUpload }: IProps) => {
    const dispatch = useAppDispatch();
    const activeBrand = useAppSelector(getActiveBrand);
    const assetsHasNext = useAppSelector(getAssetshasNext);
    const assetsPage = useAppSelector(getAssetsPage);
    const [fetchUploadedAssets] = useLazyGetUploadedAssetsQuery();

    const [tempImageUrl, setTempImageUrl] = useState<IUploadedAsset | null>(null);
    const [tempImageFile, setTempImageFile] = useState<File | null>(null);

    const handleNo = () => {
        setTempImageUrl(null);
        setTempImageFile(null);
    };

    const fetchMoreData = async () => {
        await fetchMoreAssets(
            activeBrand,
            assetsHasNext,
            fetchUploadedAssets,
            assetsPage,
            dispatch,
        );
    };

    return (
        <>
            {tempImageFile || tempImageUrl ? (
                <ShowSelectedImage
                    handleNo={handleNo}
                    tempImageUrl={tempImageUrl}
                    setTempImageUrl={setTempImageUrl}
                    tempImageFile={tempImageFile}
                    setTempImageFile={setTempImageFile}
                    onHide={onHide}
                    onUpload={onUpload}
                />
            ) : (
                <ImagesForm
                    tempImageUrl={tempImageUrl}
                    setTempImageUrl={setTempImageUrl}
                    tempImageFile={tempImageFile}
                    setTempImageFile={setTempImageFile}
                    fetchMoreData={fetchMoreData}
                    show={show}
                />
            )}
        </>
    );
};

export default AssetsImages;
